import styled from 'styled-components';
import { media } from '../mixins';

const Layout = styled.div`
  display: grid;
  ${media.desktop`display:block;`};
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  grid-template-areas: 'left-top center right-top' 'left center right' 'left-bottom center right-bottom';
  grid-template-columns: 1fr 800px 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  ${media.desktop`grid-template-areas: "left-top" "center" "right-top" "left" "right" "left-bottom" "right-bottom";grid-template-columns:1fr;}`}
  justify-items: ${({ justify = 'center' }) => justify};
`;

export default Layout;
export const LayoutItem = styled.div`
  grid-area: ${({ area = 'center' }) => area};
  ${({ area }) => (!area || area === 'center' ? 'width:100%;' : '')};
  display: ${({ display = 'block' }) => display};
  height: ${({ height = '100%' }) => height};
  width: ${({ width = '100%' }) => width};
  maxwidth: ${area => (area !== 'center' ? 'max-width:20vw;' : '')}
    ${({ area }) =>
      area === 'left' && 'margin-right:auto;padding: 1em;margin-left:20px; '};
  ${({ area }) =>
    area === 'right' && 'margin-left:auto;padding:1em;margin-right:20px'};
  ${media.desktop`height:auto;padding:0.5em;box-sizing:border-box;max-width:100%;`};
`;
